<template>
  <q-icon name="tune" size="18px" color="secondary-1" class="cursor-pointer">
    <RPopup :items="allColumns" dont-close-on-click @popup-item="showOrHideColumn">
      <template #before="{ item, index }">
        <q-item-section side>
          <RCheckbox
            :disable="item.disable"
            :value="item.visible"
            :val="item.visible"
            @input="showOrHideColumn(item, index)"
          />
        </q-item-section>
      </template>
    </RPopup>
  </q-icon>
</template>

<script>
import RPopup from '@/ui/RPopup'

export default {
  components: {
    RPopup
  },

  props: {
    agGrid: {
      required: true
    }
  },

  data: () => ({
    allColumns: []
  }),

  watch: {
    agGrid(newVal) {
      if (newVal) {
        this.setAllColumns()
      }
    }
  },

  methods: {
    showOrHideColumn(col, index) {
      this.$emit('column-toggle', col)
      this.agGrid.columnApi.setColumnVisible(col.name, !col.visible)
      this.allColumns[index].visible = !col.visible
    },

    setAllColumns() {
      this.allColumns = this.agGrid.api
        .getColumnDefs()
        .filter(col => !col.colId.includes('spacer'))
        .map(col => ({
          name: col.colId,
          label: col.headerName,
          disable: col.lockVisible,
          visible: !col.hide
        }))
    }
  }
}
</script>
